import CourseSyllabus from "../common/CourseSyllabus/CourseSyllabus";

 

const pythonSyllabus = {
    basic: [
        {
            id: "python-basic-1",
            title: "Understanding Programming Languages",
            content: [
                "Overview of different types of programming languages",
                "What constitutes a programming language?",
                "Classifications: Low-level, high-level, scripting, and markup languages",
                "Role of translators in coding — compiler vs interpreter",
                "Explanation of scripting languages with examples",
                "Comparing scripting and programming languages",
                "Procedural vs Object-Oriented Programming styles",
                "Concept of programming paradigms",
            ],
        },
        {
            id: "python-basic-2",
            title: "Introduction to Python Language",
            content: [
                "What is Python and why is it widely used?",
                "Evolution and timeline of Python as a language",
                "Key characteristics: Interpreted, dynamic, object-oriented, modular, embeddable, extensible",
                "Uses of Python in diverse industries and real-time environments",
                "Python as a general-purpose tool",
                "A few constraints and limitations Python developers should know",
                "What is PSF and its role in Python development",
                "Major implementations and distributions of Python (CPython, Jython, etc.)",
                "Applications of Python in domains like AI, automation, web, etc.",
                "Real-time adoption of Python in industries",
                "Key differences across versions: Python 2.x vs 3.x, 3.7 vs 3.8",
                "Software development lifecycle in Python environments",
                "Python tools and software distributions",
            ],
        },
        {
            id: "python-basic-3",
            title: "Installation and Development Setup",
            content: [
                "How to download and install Python on different platforms (Windows, Linux, Unix, Mac)",
                "Setting up PATH environment variables",
                "Overview of online interpreters and offline development tools",
                "IDEs widely used in the industry: Jupyter Notebook, Spyder, PyCharm, Rodeo, VS Code, ATOM, PyDev, etc.",
                "Comparison between editors and full IDEs",
                "Using Python in online coding environments", 
            ],
        },
        {
            id: "python-basic-4",
            title: "Python Fundamentals",
            content: [
                "Overview of Python’s language structure and grammar",
                "Comments in Python",
                "Statements and expressions",
                "Keywords and identifiers",
                "Python coding conventions", 
            ],
        },
        {
            id: "python-basic-5",
            title: "Python Internals & Execution",
            content: [
                "How Python code is executed",
                "Python interpreter",
                "Source code and bytecode",
                "Python Virtual Machine (PVM)",
                "Compilation and interpretation",
                "Understanding Python execution flow",
            ],
        },
        {
            id: "python-basic-6",
            title: "Working with Variables",
            content: [
                "Understanding variables",
                "Variable declaration and assignment",
                "Dynamic typing in Python",
                "Naming conventions",
                "Multiple variable assignment",
                "Constants and naming practices",
                "Variable scope basics",
            ],
        },
        {
            id: "python-basic-7",
            title: "Data Input, Output, and Type Conversion",
            content: [
                "Using input() function",
                "Displaying output using print()",
                "Formatted output",
                "Understanding Python data types",
                "Type conversion",
                "int(), float(), str(), and bool()",
                "Implicit and explicit conversion",
            ],
        },
        {
            id: "python-basic-8",
            title: "Operators in Python",
            content: [
                "Arithmetic operators",
                "Comparison operators",
                "Logical operators",
                "Assignment operators",
                "Bitwise operators",
                "Membership operators",
                "Identity operators",
                "Operator precedence and associativity",
            ],
        },
        {
            id: "python-basic-9",
            title: "Decision Making and Loops",
            content: [
                "if statement",
                "if-else statement",
                "if-elif-else statements",
                "Nested conditions",
                "for loops",
                "while loops",
                "break statement",
                "continue statement",
                "pass statement",
            ],
        },
        {
            id: "python-basic-10",
            title: "Python Data Structures (Collections)",
            content: [
                "Lists",
                "Tuples",
                "Sets",
                "Dictionaries",
                "Indexing and slicing",
                "Adding and removing collection elements",
                "Iterating through collections",
                "Collection methods",
            ],
        },
        {
            id: "python-basic-11",
            title: "Functions in Python",
            content: [
                "What are functions?",
                "Defining and calling functions",
                "Function parameters and arguments",
                "Return values",
                "Default arguments",
                "Keyword arguments",
                "Variable-length arguments",
                "Lambda functions",
                "Local and global scope",
            ],
        },
    ],

    intermediate: [
        {
            id: "python-intermediate-12",
            title: "Modular Programming with Python",
            content: [
                "Understanding modules",
                "Creating custom modules",
                "Importing modules",
                "from and import statements",
                "Python standard library",
                "Packages and package structure",
                "Using __name__ and __main__",
            ],
        },
        {
            id: "python-intermediate-13",
            title: "Object-Oriented Programming in Python (OOPs)",
            content: [
                "Introduction to Object-Oriented Programming",
                "Classes and objects",
                "Constructors",
                "Instance variables and methods",
                "Class variables and methods",
                "Encapsulation",
                "Inheritance",
                "Polymorphism",
                "Abstraction",
                "Method overriding",
            ],
        },
        {
            id: "python-intermediate-14",
            title: "Exception Handling and Error Management",
            content: [
                "Understanding errors and exceptions",
                "try and except",
                "Handling multiple exceptions",
                "else block",
                "finally block",
                "Raising exceptions",
                "Custom exceptions",
                "Best practices for exception handling",
            ],
        },
        {
            id: "python-intermediate-15",
            title: "Regular Expressions in Python",
            content: [
                "Introduction to regular expressions",
                "Python re module",
                "Matching patterns",
                "Searching and replacing text",
                "Character classes",
                "Quantifiers",
                "Groups and capturing",
                "Practical validation examples",
            ],
        },
        {
            id: "python-intermediate-16",
            title: "File Handling and Directory Operations",
            content: [
                "Opening and closing files",
                "Reading files",
                "Writing files",
                "Appending data",
                "File modes",
                "Working with CSV files",
                "Working with JSON files",
                "Directory operations",
                "Path handling",
            ],
        },
        {
            id: "python-intermediate-17",
            title: "Logging in Python",
            content: [
                "Introduction to application logging",
                "Python logging module",
                "Logging levels",
                "Creating loggers",
                "File logging",
                "Formatting log messages",
                "Exception logging",
                "Logging best practices",
            ],
        },
        {
            id: "python-intermediate-18",
            title: "Date, Time, and Calendar Modules",
            content: [
                "datetime module",
                "date and time objects",
                "Formatting dates and times",
                "Parsing date strings",
                "Time differences",
                "Calendar module",
                "Working with time zones",
            ],
        },
        {
            id: "python-intermediate-19",
            title: "OS-Level Operations",
            content: [
                "Python os module",
                "Working with directories",
                "Creating and deleting files",
                "Environment variables",
                "Current working directory",
                "Executing system commands",
                "shutil module",
                "Path management",
            ],
        },
        {
            id: "python-intermediate-20",
            title: "Multithreading and Multiprocessing",
            content: [
                "Introduction to concurrency",
                "Threads in Python",
                "threading module",
                "Creating and managing threads",
                "Thread synchronization",
                "Processes in Python",
                "multiprocessing module",
                "Threads vs processes",
                "Practical concurrency examples",
            ],
        },
        {
            id: "python-intermediate-21",
            title: "Garbage Collection in Python",
            content: [
                "Understanding memory management",
                "Reference counting",
                "Python garbage collector",
                "gc module",
                "Circular references",
                "Object lifecycle",
                "Memory optimization basics",
            ],
        },
    ],

    advanced: [
        {
            id: "python-advanced-22",
            title: "Python and Database Integration (PDBC)",
            content: [
                "Introduction to database programming",
                "Connecting Python with databases",
                "Working with SQLite",
                "Database drivers",
                "Creating database connections",
                "Executing SQL queries",
                "Insert, update, delete, and select operations",
                "Transactions",
                "Database error handling",
            ],
        },
        {
            id: "python-advanced-23",
            title: "Python Networking and Socket Programming",
            content: [
                "Introduction to computer networking",
                "IP addresses and ports",
                "TCP and UDP",
                "Python socket module",
                "Creating socket clients",
                "Creating socket servers",
                "Client-server communication",
                "Sending and receiving data",
            ],
        },
        {
            id: "python-advanced-24",
            title: "Graphical User Interfaces (GUI) – Tkinter & Turtle",
            content: [
                "Introduction to GUI programming",
                "Tkinter fundamentals",
                "Creating windows",
                "Labels, buttons, and input controls",
                "Frames and layouts",
                "Event handling",
                "Creating forms",
                "Introduction to Turtle graphics",
                "Building simple GUI applications",
            ],
        },
        {
            id: "python-advanced-25",
            title: "Python for Data Analysis and Scientific Computing",
            content: [
                "Introduction to data analysis",
                "NumPy fundamentals",
                "Arrays and operations",
                "Pandas DataFrames",
                "Reading CSV and Excel data",
                "Data cleaning",
                "Data filtering and transformation",
                "Matplotlib basics",
                "Data visualization",
            ],
        },
        {
            id: "python-advanced-26",
            title: "Introduction to Machine Learning & Data Science",
            content: [
                "Introduction to Data Science",
                "Machine Learning fundamentals",
                "Supervised and unsupervised learning",
                "Training and testing datasets",
                "Features and labels",
                "Introduction to Scikit-learn",
                "Regression basics",
                "Classification basics",
                "Model evaluation",
            ],
        },
        {
            id: "python-advanced-27",
            title: "Web Development Using Django Framework",
            content: [
                "Introduction to Django",
                "Django installation and setup",
                "Creating a Django project",
                "Django applications",
                "URLs and views",
                "Templates",
                "Models",
                "Django ORM",
                "Forms",
                "Building a complete web application",
            ],
        },
    ],
};


function PythonSyllabus() {
    return (
        <CourseSyllabus
            courseName="Python"
            syllabus={pythonSyllabus}
        />
    );
}

export default PythonSyllabus;